"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentApiVersionRegistry = void 0;
exports.findEndpointVersion = findEndpointVersion;
exports.getAppointmentEndpointVersion = getAppointmentEndpointVersion;
exports.AppointmentApiVersionRegistry = [
    { endpoint: 'createAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'walkInAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'emergencyAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'corporateAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'referralAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'telemedicineAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'healthCheckAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'packageAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'rescheduleAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'cancelAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'confirmAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'appointmentExpiry', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'patientArrival', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'patientCheckIn', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'lateArrival', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'noShow', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'completeAppointment', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    // P0-3 — the queue read, closing the debt this module recorded in its own routes file.
    { endpoint: 'listQueue', version: 'v1', status: 'STABLE', introducedIn: 'P0-3' },
    { endpoint: 'generateQueue', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'generateToken', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'moveQueue', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'recallPatient', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'skipPatient', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'priorityQueue', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'joinWaitlist', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'promoteWaitlist', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'expireWaitlist', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'getAvailableSlots', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'holdSlot', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'releaseSlot', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'createSchedule', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'updateSchedule', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'doctorLeave', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'availabilityOverride', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'scheduleReminder', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
    { endpoint: 'cancelReminder', version: 'v1', status: 'STABLE', introducedIn: '5B.5' },
];
/** Generic lookup over any registry — reused by both bounded contexts rather than each defining its own resolver (`getEndpointVersion` stays as-is, scoped to `PatientApiVersionRegistry`, for backward compatibility). */
function findEndpointVersion(endpoint, registry) {
    return registry.find((entry) => entry.endpoint === endpoint);
}
function getAppointmentEndpointVersion(endpoint) {
    return findEndpointVersion(endpoint, exports.AppointmentApiVersionRegistry);
}
//# sourceMappingURL=appointment-api-version-registry.js.map